

<template>
  <div class="page-main">
    <div class="top-tip">
      长按分享或保存图片
    </div>
    <div class="report-dialog">
      <div v-if="!url" class="page-content" id="weightChart">

        <!-- 体重曲线 -->
        <div class="weight-box">
          <div class="echart-main" ref="chartColumn"></div>
          <div class="weight-header">
            <div class="header">
              <div class="title">体重曲线</div>
              <div class="unit">单位：kg</div>
            </div>
<!--            <div class="tab-list">-->
<!--              <div @click="tabChange(0)" :class="type == 0 ? 'active tab-item' : 'tab-item'">近7天</div>-->
<!--              <div @click="tabChange(1)" :class="type == 1 ? 'active tab-item' : 'tab-item'">3个月</div>-->
<!--              <div @click="tabChange(2)" :class="type == 2 ? 'active tab-item' : 'tab-item'">6个月</div>-->
<!--            </div>-->

          </div>
        </div>

      </div>
      <div v-else class="img-box">
        <img :src="url" />
      </div>

      <div v-if="!url" class="loading"><img :src="loading" /></div>
      <!-- <div class="btn-footer">
      <div class="btn" @click="saveImg">
        保存到相册并分享
      </div>
    </div> -->
    </div>
  </div>
</template>

<script>
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import { htmlToPDF } from "../utils/html2pdf";
import dietitian from '../assets/images/dietitian.jpg';
import doctor from '../assets/images/doctor.png';
import loading from '../assets/images/pending.gif'
import * as echarts from 'echarts';

var chart = null;
export default {
  data() {
    return {
      loading,
      doctor,
      dietitian,
      doctorName: "",
      dietitianName: "",
      type: 0,
      recordInfo: {},
      commentList: [],
      url: '',
    };
  },
  mounted() {
    document.title = '体重折线图';
    this.id = getQueryString('id');
    this.endTime = getQueryString('endTime');

    // this.id = "1877168509061201921";
    // this.endTime = '2025-02-20';

    this.getShareData();
  },

  methods: {
    getShareData() {
      this.getWeightList();
    },
    getWeightList() {
      ajax
        .Post({
          url: '/api/loss/weight/searchWeightCurve',
          data: { endTime: this.endTime, "patientId": this.id, type: this.type }
        }).then(({ data: { success, data } }) => {
          if (success && data) {
            let xAxisData = data.map(item => item.createdTime)
            let yData = data.map(item => item.score)
            let yAxis = {
              min: yData.length ? Math.min(...yData) - 1 : 0
            }
            this.initEcharts({ xAxisData, yData, yAxis })

          } else {
            this.initEcharts({ xAxisData: [], yData: [], yAxis: {} })
          }
        })
    },
    tabChange(type) {
      this.type = type;
      this.getWeightList()
    },
    saveImg() {
      htmlToPDF('weightChart', '体重折线图').then(url => {
        this.url = url
      });
    },
    initEcharts({ xAxisData, yData, yAxis }) {
      let that = this;
      let seriesData = [{
        type: "line",
        smooth: true,
        tooltip: false,
        grid: {
          right: 'right',
          bottom: 0,
          containLabel: true
        },
        data: yData,
        itemStyle: {
          normal: {
            color: "#fff", // 折线点的颜色
            lineStyle: {
              color: "#fff" // 折线的颜色
            },
            label: {
              show: false,
              color: "#fff"
            }
          }
        },
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              {
                offset: 0,
                color: "#FFC973"
              },
              {
                offset: 1,
                color: "#FFC469"
              }
            ],
            global: false
          }
        }
      }]

      let option = {
        backgroundColor: 'transparent', // 设置背景颜色
        xAxis: {
          data: xAxisData,
          axisLabel: {
            color: "#FFFFFF", // 设置坐标轴标签为白色
          },
          axisLine: {
            show: false
          },
          axisTick: {
            lineStyle: {
              color: "#e7e7e7"
            }
          }
        },
        yAxis: [{
          ...yAxis,
          showMaxLabel: true,
          axisLabel: {
            color: "#FFFFFF", // 设置坐标轴标签为白色
          },
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed"
            }
          },
        }],
        series: seriesData
      }

      if (!chart) {
        chart = echarts.init(this.$refs.chartColumn);
      }
      chart.setOption(option);
      chart.on('finished', function () {
        console.log('ECharts 图表加载完成！');
        setTimeout(() => {
          that.saveImg()
        }, 200);
      });
    }
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.loading {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  background: rgba(0, 0, 0, .2);
}

.loading img {
  width: 50px;
  height: 50px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.page-main {
  padding: 20px 10px;
  background-color: #eaedf2;
}

.d-f {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 15px;
}

.d-f .f-box {
  flex: 1;
  padding: 15px 9px;
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 5px;
  border-radius: 7px;
  background-color: #fff;
}

.d-f .f-box .box-avatar {
  width: 37px;
  height: 37px;
  border-radius: 50%;
}

.d-f .f-box .box-name {
  font-size: 15px;
  color: #666666;
}

/* 页面下载内容 */
.report-dialog {
  position: relative;
  min-height: 100vh;
  height: auto;
  /* overflow: auto; */
  /* padding-bottom: 90px; */
  /* background-color: #FBB13D; */
}

.page-content {
  width: 100%;
  height: auto;
  /*background-color: #FFC364;*/
  /*padding: 24px 12px;*/
  background: linear-gradient(to bottom, #FFC364, #FBB13D);
}


/* 体重曲线样式 */
.weight-box {
  width: 100%;
  height: 270px;
  position: relative;
  border-radius: 7px;
  overflow: hidden;
  margin-bottom: 14px;
}

.echart-main {
  width: 100%;
  height: 305px;
  padding-top: 10px;
  padding-left: 18px;
  padding-bottom: 0px;
}

.weight-header {
  position: absolute;
  top: 0;
  width: 100%;
  height: 70px;
  padding: 14px;
}

.weight-header .header,
.weight-header .tab-list {
  width: 100%;
  display: flex;
  height: 20px;
  justify-content: space-between;
  align-items: center;
}

.weight-header .header .title {
  font-size: 15px;
  color: #fff;
}

.weight-header .header .unit {
  font-size: 11px;
  color: #fff;
}

.weight-header .tab-list {
  justify-content: start;
  gap: 7px;
}

.tab-list .tab-item {
  width: 38px;
  height: 16px;
  text-align: center;
  font-size: 9px;
  color: #999;
  border-radius: 8px;
  border: 1px solid #E8E9EC;

}

.tab-list .tab-item.active {
  background: #FBB13D;
  border-color: #FBB13D;
  color: #Fff;
}

/* 变化记录 */
.change-record {
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
  padding: 14px 37px 14px 26px;
  background: #FFFFFF;
  border-radius: 7px;
  margin-bottom: 4px;
}

.change-record .change-item {
  height: 44px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

.change-record .change-item .top-title {
  font-size: 13px;
  color: #666666;
}

.change-record .change-item .bottom-num {
  font-size: 18px;
  color: #333;
}

.change-record .change-item .bottom-num.s-num {
  color: #5ED1A9;
  font-weight: 500;
}

/* 点评样式 */
.card-title {
  width: 100%;
  height: 40px;
  font-weight: 500;
  font-size: 15px;
  color: #FFFFFF;
  line-height: 40px;
}

.card-con {
  width: 100%;
  height: auto;
  padding: 14px;
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  background: #FFFFFF;
  border-radius: 7px;
  margin-bottom: 4px;
}

/* 底部分享卡片 */
.share-card {
  width: 100%;
  height: auto;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 16px;
  background-color: #fff;
  border-radius: 7px;
}

.share-card .left-img {
  width: 48px;
  height: 48px;
}

.share-card .right {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.share-card .right .title {
  font-size: 12px;
  color: #333333;
}

.share-card .right .tip {
  font-size: 10px;
  color: #999999;
}

/* 底部按钮 */
.btn-footer {
  position: fixed;
  bottom: 0;
  left: 0px;
  width: 100%;
  height: 83px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #FFFFFF;
  box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  padding-bottom: 27px;
}

.btn {
  width: 343px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 1px;
  background: #FBB13D;
  border-radius: 24px;
}

.history-loading {
  width: 100%;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, 50%);
}


.img-box {
  width: 100%;
  height: auto;
  /* position: absolute;
  top: 0 */
}

.img-box img {
  width: 100%;
  height: auto;
}

.top-tip {
  color: #777;
  color: #FE5B59;
  font-size: 16px;
  font-weight: 500;
  text-align: center;
  padding-bottom: 20px;
}
</style>

